export const SITE_NAME = 'Esri Land Cover 2050';
export const TOP_BANNER_TITLE = 'Esri Land Cover 2050';
export const TOP_BANNER_DESCRIPTION = 'How will land cover change by 2050? Here’s a glimpse.';